import { setDefaultOptions } from 'date-fns'
import { flatten } from 'flat'
import { useEffect, useState } from 'react'

import { getCurrentLocale, importDateLocale, loadMessages } from '../lib/locale'

type UseLocaleInitializationReturn = {
  isReady: boolean
  locale: string
  messages: Record<string, string>
}

export function useLocaleInitialization(): UseLocaleInitializationReturn {
  const [isReady, setIsReady] = useState(false)
  const [locale, setLocale] = useState('en')
  const [messages, setMessages] = useState<Record<string, string>>({})

  useEffect(() => {
    const currentLocale = getCurrentLocale()
    setLocale(currentLocale)

    Promise.all([importDateLocale(currentLocale), loadMessages(currentLocale)])
      .then(([dateLocale, localeMessages]) => {
        if (dateLocale) {
          setDefaultOptions({ locale: dateLocale })
        }
        const flattenedMessages = flatten(localeMessages)
        // Ensure all values are strings for IntlProvider
        const stringMessages: Record<string, string> = {}
        if (flattenedMessages && typeof flattenedMessages === 'object') {
          for (const [key, value] of Object.entries(flattenedMessages)) {
            stringMessages[key] = String(value)
          }
        }
        setMessages(stringMessages)
        setIsReady(true)
      })
      .catch((error) => {
        console.error('Failed to initialize locale data:', error)
        setIsReady(true)
      })
  }, [])

  return {
    isReady,
    locale,
    messages,
  }
}
